<app-breadcrumb></app-breadcrumb>

<div class="container mt-2">
  <app-system-wide-message></app-system-wide-message>
  <app-embedded-map></app-embedded-map>
  <div *ngFor="let route of routes">
    <div class="mx-auto" *ngIf="route.id.toLowerCase() == detailedRoute.id.toLowerCase()">
      <span class="badge">Schedule</span>
      <div class="route-label">
        <div class="route-name">
          <h2> {{ route.name }} </h2>
        </div>
        <div class="route-details mb-2">
          <strong>
            <div class=""> {{ route.description }} </div>
          </strong>
        </div>
        <app-route-status-button></app-route-status-button>
        <button type="button" class="btn btn-outline-secondary ml-1"
          routerLink="/schedule/timetable/{{route.id}}">Timetable</button>
        <a href="{{pdfUrl}}" class="btn btn-outline-secondary ml-1">PDF</a>
        <ng-container *ngFor="let schedule of scheduledPdf">
          <a href="{{schedule.location}}" class="btn btn-outline-secondary ml-1">{{ schedule.description }}</a>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="row pt-3">
    <div class="form-group col">
      <label for="directionControlSelect">Direction</label>
      <select class="form-control" id="directionControlSelect" (change)="onDirectionChange($event.target.value)">
        <option *ngFor="let direction of directions" [selected]="direction['Direction']== selected_direction"
          [value]="direction['Direction']" [innerHTML]="direction.DirectionDescription"></option>
      </select>
    </div>
    <div class="form-group col">
      <label for="stopControlSelect">Stop</label>
      <select class="form-control" id="stopControlSelect" (change)="onStopChange($event.target.value)">
        <option value="0">Select a stop</option>
        <option *ngFor="let stop of stops" [selected]="stop.stop_id == selected_stop" [value]="stop.stop_id"
          [innerHTML]="stop.stop_name"></option>
      </select>
    </div>
  </div>

  <div class="row d-flex p-2 mt-2 text-center" *ngIf="stop_times">
    <nav>
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a class="nav-item nav-link active" id="nav-today-tab" data-toggle="tab" href="#nav-today" role="tab"
          aria-controls="nav-today" aria-selected="true">
          <span class="badge">
            Today
          </span>
        </a>

        <a class="nav-item nav-link" id="nav-week-tab" data-toggle="tab" href="#nav-week" role="tab"
          aria-controls="nav-week" aria-selected="false">
          <span class="badge">
            Mon-Fri
          </span>
        </a>

        <a class="nav-item nav-link" id="nav-sat-tab" data-toggle="tab" href="#nav-sat" role="tab"
          aria-controls="nav-sat" aria-selected="false">
          <span class="badge">
            Sat
          </span>
        </a>
        <a class="nav-item nav-link" id="nav-sun-tab" data-toggle="tab" href="#nav-sun" role="tab"
          aria-controls="nav-sun" aria-selected="false">
          <span class="badge">
            Sun
          </span>
        </a>
      </div>
    </nav>
  </div>
  <div class="tab-content" id="nav-tabContent">
    <br />
    <div class="tab-pane fade show active" id="nav-today" role="tabpanel" aria-labelledby="nav-today-tab">
      <app-schedule-route-today></app-schedule-route-today>
    </div>
    <div class="tab-pane fade" id="nav-week" role="tabpanel" aria-labelledby="nav-week-tab">
      <table class="table table-bordered" *ngIf="stop_times">
        <thead>
          <tr>
            <th scope="col">Block</th>
            <th scope="col">Destination</th>
            <th scope="col">Departure</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let times of stop_times">
            <ng-container *ngIf="calendar['Weekday'] != null">
              <ng-container *ngIf="calendar['Weekday'].includes(times.service_id)">
                <td *ngIf="times.schedule_day == 'Weekday'"><a routerLink="/schedule/trip/{{times.trip_id }}">
                    {{ times.block_id }} </a></td>
                <td *ngIf="times.schedule_day == 'Weekday'"> {{ times.trip_headsign }} </td>
                <td *ngIf="times.schedule_day == 'Weekday'"> {{ times.arrival_time }} </td>
              </ng-container>
            </ng-container>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="tab-pane fade" id="nav-sat" role="tabpanel" aria-labelledby="nav-sat-tab">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th scope="col">Block</th>
            <th scope="col">Destination</th>
            <th scope="col">Departure</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let times of stop_times">
            <ng-container *ngIf="calendar['Saturday'] != null">
              <ng-container *ngIf="calendar['Saturday'].includes(times.service_id)">
                <td *ngIf="times.schedule_day == 'Saturday'"><a routerLink="/schedule/trip/{{times.trip_id }}">
                    {{ times.block_id }} </a></td>
                <td *ngIf="times.schedule_day == 'Saturday'"> {{ times.trip_headsign }} </td>
                <td *ngIf="times.schedule_day == 'Saturday'"> {{ times.arrival_time }} </td>
              </ng-container>
            </ng-container>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="tab-pane fade" id="nav-sun" role="tabpanel" aria-labelledby="nav-sun-tab">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th scope="col">Block</th>
            <th scope="col">Destination</th>
            <th scope="col">Departure</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let times of stop_times">
            <ng-container *ngIf="calendar['Sunday'] != null">
              <ng-container *ngIf="calendar['Sunday'].includes(times.service_id)">
                <td *ngIf="times.schedule_day == 'Sunday'"><a routerLink="/schedule/trip/{{times.trip_id }}">
                    {{ times.block_id }} </a></td>
                <td *ngIf="times.schedule_day == 'Sunday'"> {{ times.trip_headsign }} </td>
                <td *ngIf="times.schedule_day == 'Sunday'"> {{ times.arrival_time }} </td>
              </ng-container>
            </ng-container>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<app-main-footer></app-main-footer>
